const SidebarData = [
  {
    label: "Analytics",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-chart-bar",
    url: "/analytics/dashboard",
    isHasArrow: true,
  },

  {
    label: "Users",
    isMainMenu: true,
  },
  {
    label: "Users",
    icon: "mdi mdi-account-group",
    url: "/users",
    bgcolor: "bg-primary",
    badgeValue: "3",
    isHasArrow: true,
  },

  {
    label: "Packs",
    isMainMenu: true,
  },
  {
    label: "All Packs",
    icon: "mdi mdi-shield-account",
    url: "/all-packs",
    bgcolor: "bg-primary",
    badgeValue: "3",
    isHasArrow: true,
  },

  {
    label: "All Items",
    icon: "mdi mdi-bank-transfer-out",
    url: "/items",
    bgcolor: "bg-warning",
    isHasArrow: true,
  },

  //battle
  {
    label: "Battle",
    isMainMenu: true,
  },
  {
    label: "Total Battles",
    icon: "mdi mdi-shield-account",
    url: "/total-battle",
    bgcolor: "bg-primary",
    badgeValue: "3",
    isHasArrow: true,
  },

  {
    label: "In Live",
    icon: "mdi mdi-bank-transfer-out",
    url: "/in-live",
    bgcolor: "bg-warning",
    isHasArrow: true,
  },

  //Transaction
  {
    label: "Transaction",
    isMainMenu: true,
  },
  {
    label: "Admin Account Details",
    icon: "mdi mdi-shield-account",
    url: "/adminaccountdetails",
    bgcolor: "bg-primary",
    badgeValue: "3",
    isHasArrow: true,
  },
  {
    label: "User Deposit History",
    icon: "mdi mdi-bank-transfer-in",
    url: "/deposithistory",
    bgcolor: "bg-warning",
    isHasArrow: true,
  },
  {
    label: "User Withdraw History",
    icon: "mdi mdi-bank-transfer-out",
    url: "/withdrawhistory",
    bgcolor: "bg-warning",
    isHasArrow: true,
  },

  //Casino Game
  // {
  //   label: "Casino Game ",
  //   isMainMenu: true,
  // },
  // {
  //   label: "User Game History",
  //   icon: "mdi mdi-slot-machine",
  //   url: "/gamehistory",
  //   bgcolor: "bg-warning",
  //   isHasArrow: true,
  // },

  //Matches
  // {
  //   label: "Matches",
  //   isMainMenu: true,
  // },
  // {
  //   label: "Matches",
  //   icon: "mdi mdi-trophy",
  //   url: "/mathces",
  //   bgcolor: "bg-primary",
  //   badgeValue: "3",
  //   isHasArrow: true,
  // },
  // {
  //   label: "Trade History",
  //   icon: "mdi mdi-chart-line",
  //   url: "/usertradehistory",
  //   bgcolor: "bg-primary",
  //   badgeValue: "3",
  //   isHasArrow: true,
  // },
  // {
  //   label: "Settlement History",
  //   icon: "mdi mdi-cash-check",
  //   url: "/settlemethistory",
  //   bgcolor: "bg-primary",
  //   badgeValue: "3",
  //   isHasArrow: true,
  // },

  // {
  //     label: "IMM",
  //     icon: "mdi mdi-account-group",
  //     url: "/market-makers",
  //     bgcolor: "bg-primary",
  //     badgeValue: "3",
  //     isHasArrow: true,
  // },

  // {
  //     label: "Events",
  //     icon: "mdi mdi-alpha-e-circle",
  //     subItem:[
  //         {sublabel:"Events", link:"/events"},
  //         {sublabel:"Closing Events", link:"/closing-events"},
  //     ]
  // },

  {
    label: "Master",
    isMainMenu: true,
  },

  {
    label: "Admins",
    icon: "mdi mdi-shield-account",
    url: "/admins",
    bgcolor: "bg-primary",
    badgeValue: "3",
    isHasArrow: true,
  },
];
export default SidebarData;
